export enum LicenseFilterType {
  ShowAll = 'ShowAll',
  ShowAssigned = 'ShowAssigned',
  ShowUnassigned = 'ShowUnassigned',
}
